export const STAFF_ROUTES = {
	COMMUNITIES: "/admin/communities",
	COMMUNITY_DETAIL: "/admin/communities/:communityId",
	COMMUNITY_MEMBERS: "/admin/communities/:communityId/members",
	COMMUNITY_MOBILE_APP: "/admin/communities/:communityId/mobile-app",
} as const;

export const buildCommunityDetailRoute = (communityId: string) => `/admin/communities/${communityId}`;
export const buildCommunityMembersRoute = (communityId: string) => `/admin/communities/${communityId}/members`;
export const buildCommunityMobileAppRoute = (communityId: string) => `/admin/communities/${communityId}/mobile-app`;
